import MasterCrudPage from '../../components/MasterCrudPage';

export default function Grades() {
  return (
    <MasterCrudPage
      config={{
        title: 'Grade',
        apiBase: '/pas/masters/grades',
        listKey: 'grades',
        entityKey: 'grade',
        hasCodeName: false,
        fields: [
          { key: 'name', label: 'Grade Name', type: 'text', maxLength: 50, required: true },
          { key: 'valueFrom', label: 'Value From (%)', type: 'number', required: true },
          { key: 'valueTo', label: 'Value To (%)', type: 'number', required: true },
        ],
      }}
    />
  );
}
